import KDSCateoryPage from 'pages/kds/kdscategory';
import React from 'react';

function KDSCategory() {
  return <KDSCateoryPage />;
}

export default KDSCategory;
